import React, { useState } from "react";
import { motion } from "framer-motion";
import Popup from "../components/Popup";
import WebinarFormPopup from "../components/WebinarFormPopup";
import { FaVideo, FaTools, FaInfinity, FaBriefcase } from "react-icons/fa";
import Careerbanner from "../components/Career-banner";
import CareersSection from "../components/Careers/CareersSection";
import CardSection from "../components/Careers/CardSection";
import CareerForm from "../components/Careers/CareerForm";


function Offers() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const openPopup = (content) => {
    setPopupContent(content);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupContent(null);
  };


  return (
    <>
      {/* Banner Animation */}
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Careerbanner />
      </motion.div>

      {/* Staggered Sections */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ staggerChildren: 0.25 }}
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0 },
        }}
      >

        <motion.div variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } }}>
          <CareersSection />
        </motion.div>
        <motion.div variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } }}>
          <CardSection />
        </motion.div>
        <motion.div variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } }}>
          <CareerForm />
           <p style={{textAlign: "center"}}><b>Note: </b>All roles are offered on a Contract Basis which provides professional fee and commission wherever applicable.</p>
        </motion.div>
        
      </motion.div>

      {/* Popup Animation */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: isPopupOpen ? 1 : 0, scale: isPopupOpen ? 1 : 0.8 }}
        transition={{ duration: 0.3 }}
      >
        {isPopupOpen && (
          <Popup isOpen={isPopupOpen} onClose={closePopup}>
            <WebinarFormPopup onClose={closePopup} />
          </Popup>
        )}
      </motion.div>
    </>
  );
}

export default Offers;
